import React from "react";
import { SeparatorContainer, SeparatorText } from "./StepTimeSeparator.styled";
import { CalendarIcon, RightArrowIcon } from "../../../../components/Icons";
import { colors } from "../../../../theme/colors";
import { Box } from "@mui/material";

interface AppointmentTimeSeparatorProps {
  timeframeLabel: string;
}

/**
 * Time separator between appointments
 */
const AppointmentTimeSeparator: React.FC<AppointmentTimeSeparatorProps> = ({
  timeframeLabel,
}) => {
  if (!timeframeLabel) return null;

  return (
    <SeparatorContainer>
      <SeparatorText>
        <CalendarIcon width="20px" height="20px" fill={colors.text.white} />
        {timeframeLabel}
        <Box display="flex" width="20px" sx={{ transform: "rotate(90deg)" }}>
          <RightArrowIcon width="20px" height="20px" fill={colors.text.white} />
        </Box>
      </SeparatorText>
    </SeparatorContainer>
  );
};

export default AppointmentTimeSeparator;
